import React from 'react';
import DemoProductCard from './DemoProductCard';
import GeneralSettings from './settings/GeneralSettings';
import ShopSettings from './settings/ShopSettings';

const Setting = () => {
  const [settingActive, setSettingActive] = React.useState('general');

  const [currentSettings, setCurrentSettings] = React.useState(() => {
    const base = window.tpwvs_admin_settings || {};
    return {
      tpwvs_general: base.tpwvs_general || {},
      tpwvs_shop: base.tpwvs_shop || {},
      tpwvs_style: base.tpwvs_style || {},
      demo_image: base.demo_image,
    };
  });

  const handleActiveTab = (value) => setSettingActive(value);

  const handleChildChange = (partial) => {
    setCurrentSettings((prev) => {
      const next = { ...prev };
      if (partial.tpwvs_general) next.tpwvs_general = { ...(prev.tpwvs_general || {}), ...partial.tpwvs_general };
      if (partial.tpwvs_shop) next.tpwvs_shop = { ...(prev.tpwvs_shop || {}), ...partial.tpwvs_shop };
      return next;
    });
  };

  return (
    <div className="tpv-settings-page bg-gray rounded-3xl px-[1rem] sm:px-[1.5rem] md:px-[2.725rem] lg:px-[50px] xl:px-[80px] pb-[62px] py-11 h-full flex flex-col lg:flex-row gap-6">
      <div className="grid grid-cols-1 lg:w-2/3">
        <div className="tp-settings-tab">
          <div className="tpv-settings-tab-nav flex flex-wrap items-center">
            <button onClick={() => handleActiveTab('general')} type="button" className={`text-2xl font-medium px-8 py-6 hover:text-theme relative after:absolute after:content-[''] after:bottom-0 after:h-[2px] after:bg-theme after:rounded-br-md after:rounded-bl-md after:shadow-2xl after:transition after:duration-300 after:ease-in-out ${settingActive === 'general' ? 'text-theme after:left-0 after:right-auto after:w-full' : 'text-text3 after:left-auto after:right-0 after:w-0'}`}>General</button>
            <button onClick={() => handleActiveTab('shop-archive')} type="button" className={`text-2xl font-medium px-8 py-6 hover:text-theme relative after:absolute after:content-[''] after:bottom-0 after:h-[2px] after:bg-theme after:rounded-br-md after:rounded-bl-md after:shadow-2xl after:transition after:duration-300 after:ease-in-out ${settingActive === 'shop-archive' ? 'text-theme after:left-0 after:right-auto after:w-full' : 'text-text3 after:left-auto after:right-0 after:w-0'}`}>Shop/Archive</button>
          </div>

          <div className="tpv-settings-tab-content bg-white rounded-xl rounded-tl-none">
            {settingActive === 'general' && <GeneralSettings onChange={handleChildChange} />}
            {settingActive === 'shop-archive' && <ShopSettings onChange={handleChildChange} />}
          </div>
        </div>
      </div>

      <div className="lg:w-1/3 p-6 flex items-start justify-center">
        <div className="w-full max-w-2xl">
          <h3 className="text-3xl font-medium mb-6 text-center">Preview</h3>
          <DemoProductCard settings={currentSettings} />
        </div>
      </div>
    </div>
  );
};

export default Setting;
